<template>
	<ReportResultTable :card_title="card_title" reportname="FinanceReport" :reportdata="reportdata" :rowtemplates="rowtemplates" nopage="true" />
</template>

<script>

import Basic from '@/components/page/Basic.js'
import ReportResultTable from '@/views/pages/ReportResultTable.vue'
import {Config, Penanggalan, AxiosWithJar } from '@/utility.js'

export default{
	extends:Basic,
	props:["card_title", "animate", "config", "classes", "dt", "segment", "level", "plant", "reload"],
	data() {
		return {
			urlRequestParams: '',
			reportdata:[],
			rowtemplates:[
				{ slot: "ItemDesc", col: "GroupLevel", value: "3", class: "pl-group3b pl-group3a" },
				{ slot: "CostCenterNo", col: "GroupLevel", value: "3", class: "pl-group3b" },
				{ slot: "Tahun", col: "GroupLevel", value: "3", class: "pl-group3b" },
				{ slot: "Bulan", col: "GroupLevel", value: "3", class: "pl-group3b" },
				{ slot: "Amount", col: "GroupLevel", value: "3", class: "pl-group3b" },
				{ slot: "AmountYTD", col: "GroupLevel", value: "3", class: "pl-group3b" },		
			],
		}
    },
	components:{
		ReportResultTable
	},
    mounted(){
		if (!this.dt) this.dt = Penanggalan().bulanKemarin;
		if (!this.segment) this.segment = "1";
		if (!this.level) this.level = "1";
		if (!this.plant) this.plant = "";
		this.resumePilihan()
    },
	watch:
	{
		dt(){ this.resumePilihan() },
		segment(){ this.resumePilihan() },
		level(){ this.resumePilihan() },
		plant(){ this.resumePilihan() },
		reload() { this.resumePilihan() },
	},      
    methods:{
        resumePilihan(){
            this.urlRequestParams=Config().apiURL + '/finance/plreport?'
            this.urlRequestParams+='&dt='+this.dt
            this.urlRequestParams+='&segment='+this.segment
            this.urlRequestParams+='&level='+this.level
			if (this.plant) this.urlRequestParams+='&plantno='+this.plant
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                this.reportdata = response.data;

            })
        },
	}
}

</script>
<style>

	.pl-group3b {
		font-weight:bold;
	}

	.pl-group3a {
		padding-left:20px;
	}

</style>